import { Card, Flex, Tag, Typography } from "antd";
import type { CallActionCount, ReceptionistStatus } from "../../../service/calls.service";
import styles from "./call-dashboard.module.scss";

const { Text } = Typography;

const componentName = "call-dashboard";

/**
 * The practice's AI receptionist at a glance: each agent, which features are
 * switched on for it (RECEPTIONIST_EHR_CONFIG "features"), and what it did in
 * the window the dashboard is showing.
 */
const ReceptionistCard = ({
  status,
  actions,
}: {
  status?: ReceptionistStatus;
  actions?: CallActionCount[];
}) => {
  if (!status?.agents.length) return null;
  return (
    <Card className={styles[`${componentName}__receptionist`]} title="AI receptionist">
      <Flex vertical gap={12}>
        {status.agents.map((agent) => (
          <Flex key={agent.agent_identifier} wrap gap={8} align="center">
            <Text strong>{agent.platform} agent</Text>
            <Tag color={agent.is_enabled ? "green" : "default"} style={{ margin: 0 }}>
              {agent.is_enabled ? "On" : "Off"}
            </Tag>
            {status.features.map((feature) => {
              const on = agent.is_enabled && agent.features[feature.code];
              return (
                <Tag key={feature.code} color={on ? "blue" : "default"} style={{ margin: 0 }}>
                  {feature.label}
                  {on ? "" : " · off"}
                </Tag>
              );
            })}
          </Flex>
        ))}
        {actions && actions.length > 0 && (
          <Flex wrap gap={16}>
            {actions.map((action) => (
              <Text key={action.code} type={action.count ? undefined : "secondary"}>
                {action.label}: <Text strong>{action.count}</Text>
              </Text>
            ))}
          </Flex>
        )}
      </Flex>
    </Card>
  );
};

export default ReceptionistCard;
